import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

import { FRAGMENT_VISUAL_LANGUAGE } from './schema';

const MUTATION = gql`
  mutation UpdateVisualLanguage($id: ID!, $name: String!) {
    updateVisualLanguage(id: $id, name: $name) {
      ...VisualLanguage
    }
  }
  ${FRAGMENT_VISUAL_LANGUAGE}
`;

export const updateVisualLanguage = async ({ id, name }) => {
  const variables = {
    id,
    name,
  };

  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables,
  });
  return getSingleProp(result.data);
};
